import React, { forwardRef, useCallback, useState } from "react";
import { Input } from "@payping/web-components";
import type { InputProps } from "@payping/web-components/components/input";
import { FiCreditCard } from "@payping/icons";
import { panSeparator } from "@/shared/utils";

export interface PanInputProps extends Omit<InputProps, "value" | "onChange"> {
  value?: string;
  onChange?: (value: string) => void;
  maxLength?: number;
}

// TODO: REPLACE InputRef WITH HTMLInputElement
const PanInput = forwardRef<any, PanInputProps>(
  ({ value: initialValue = "", onChange, maxLength = 19, ...rest }, ref) => {
    const [value, setValue] = useState(initialValue);

    const handleInputChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replace(/[^0-9]/g, ""); // Only allow numbers, remove anything else

        const formattedValue = panSeparator(inputValue);

        setValue(formattedValue);
        onChange?.(inputValue);
      },
      [onChange],
    );

    const handleKeyDown = useCallback(
      (e: React.KeyboardEvent<HTMLInputElement>) => {
        // const containsNumber = /\d/.test(e.currentTarget.value);
        // console.log("containsNumber", containsNumber);
        // if (!containsNumber) e.currentTarget.value = "";

        if (e.key === "Backspace") {
          const caretPosition = e.currentTarget.selectionStart ?? value.length;

          if (caretPosition > 0 && value[caretPosition - 1] === "-") {
            e.preventDefault(); // Prevent the default backspace behavior
            const newCaretPosition = caretPosition - 1;

            const newValue = value.slice(0, newCaretPosition - 1) + value.slice(newCaretPosition);

            setValue(newValue);
            onChange?.(newValue);
            setTimeout(() => {
              e.currentTarget.setSelectionRange(newCaretPosition - 1, newCaretPosition - 1);
            }, 0);
          }
        }
      },
      [value, onChange],
    );

    return (
      <Input
        className="tw:text-center"
        style={{ direction: "ltr" }}
        ref={ref}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        maxLength={maxLength}
        addonAfter={<FiCreditCard width={16} />}
        {...rest}
      />
    );
  },
);

PanInput.displayName = "PanInput";
export default PanInput;
